import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'flag', 'Flag', [["path",{"d":"M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9"}],["path",{"d":"M5 21v-7"}]]);